/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostSummaryWidgetConfigurationModel extends models.BaseDataWidgetConfigurationModel {
    constructor() {
        super();
        this.setDiscriminator("CostSummaryWidgetConfigurationModel");
    }

    getFixupPrototypeFunction() { return CostSummaryWidgetConfigurationModel.fixupPrototype; }

    static newInstance(model: Partial<CostSummaryWidgetConfigurationModel>): CostSummaryWidgetConfigurationModel {
        let obj = Object.assign(new CostSummaryWidgetConfigurationModel(), model);
        CostSummaryWidgetConfigurationModel.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostSummaryWidgetConfigurationModel>): CostSummaryWidgetConfigurationModel {
        if (!model) return null;
        return CostSummaryWidgetConfigurationModel.newInstance(<CostSummaryWidgetConfigurationModel> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostSummaryWidgetConfigurationModel) {
        if (!obj) return;

        models.CostSummaryWidgetConfigurationModel.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostSummaryWidgetConfigurationModel): boolean {
        if (models.BaseDataWidgetConfigurationModel.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CostSummaryWidgetConfigurationModel.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.groupByDetails) {
            models.BillingGroupByDetails.fixupPrototype(this.groupByDetails);
        }
        if (this.groupByAccountType) {
            models.ServiceAccountNativeDetailsBase.fixupPrototype(this.groupByAccountType);
        }
    }

    /**
     * Type of cost summary
     */
    summaryType: models.CostSummaryType;

    primaryMetric: string;

    /**
     * Group by used when combined with the TopGroupBy summary type
     */
    groupByDetails: models.BillingGroupByDetails;

    /**
     * Type of Cloud Provider Account Type this applies to
     */
    groupByAccountType: models.ServiceAccountNativeDetailsBase;

}
